import { create } from 'zustand';
import { devtools, redux } from 'zustand/middleware';
import { multiColumnAutoCompleteInitialState } from './multiColumnAutoCompleteInitialState';
import { multiColumnAutoCompleteReducer } from './multiColumnAutoCompleteReducer';

export const createMultiColumnAutoCompleteStore = () =>
  create(
    devtools(
      redux(
        multiColumnAutoCompleteReducer,
        multiColumnAutoCompleteInitialState,
      ),
      {
        name: 'MultiColumnAutoCompleteStore',
      },
    ),
  );
